import { Injectable } from '@angular/core';
import { ProductModel } from '@libs/shop/models';
import { Observable } from 'rxjs';
import { ConnectorService } from '../connector';

@Injectable({ providedIn: 'root' })
export class ProductDetailRepositoryService {
  public constructor(
    private readonly connector: ConnectorService,
  ) {
  }

  public getProduct(sku: string): Observable<ProductModel> {
    return this.connector.connect('shop', 'productDetail', {
      pathParams: {
        sku,
      },
    });
  }
}
